import { render, staticRenderFns } from "./EatList.vue?vue&type=template&id=0c76bb09&"
import script from "./EatList.vue?vue&type=script&lang=js&"
export * from "./EatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports